// 商品系统--分类管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

export class CommonImgApi {
    //获取所有分类
    public static uploadImg(data) {
        // let uri = 'https://coupon.mzdata.top/coupon/api/v1/image/upload';
        let uri = '/data-dist/api/dist/fileUpload/qiNiuUpload';
        return ServerDistApi.sendImgPost(uri, data);
    }
    public static downlod(uri, data, isBlob) {
        return ServerDistApi.sendDownloadPost(uri, data, isBlob);
    }

    //下载模板
    public static downloadTemplate(uri) {
        return ServerDistApi.downloadTemplate(uri);
    }
    //本地测试
    public static testPost(url , data) {
        let uri = 'http://utopia558.i234.me:7003' + url;
        return ServerDistApi.testSendPost(uri, data);
    }

}


